import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { LoanProduct } from '@app_modules/loan-products/loan-product';
import { CheckListPayloadToFormData } from '@app_modules/requests/use-create-check-point';

interface Response extends BackendResponse {
  loanProduct: LoanProduct;
}

export interface LoanProductPayload {
  name: string;
  active: boolean;
  // document_category: string;
}

export function useCreateLoanProduct(form: UseFormReturn<LoanProductPayload>) {
  const {trans} = useTrans();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: LoanProductPayload) => createLoanProduct(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['loan-products']});
      queryClient.invalidateQueries({
        queryKey: ['billing-usage'],
      });
      toast(trans(message('Loan Product created')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function createLoanProduct(payload: LoanProductPayload) {
  return apiClient
    .post<Response>(`loan-products`, CheckListPayloadToFormData(payload))
    .then(r => r.data);
}

